import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from 'src/app/common.service';
import { Question, QuestionList } from 'question-api';
import { SystemListItem } from 'std-api';

@Component({
  selector: 'app-questions-and-answers',
  templateUrl: './questions-and-answers.component.html',
  styleUrls: ['./questions-and-answers.component.css']
})
export class QuestionsAndAnswersComponent implements OnInit {

  @Input('tenderId') tenderId: number;
  @Input('openedFrom') openedFrom: string;
  @Input('tenderTitle') tenderTitle: string;
  @Input('participationId') participationId: number;
  @Input('editable') editable: string;

  topics: SystemListItem[];

  questions: Array<Question> = [];

  topicCode: string;
  freeText: string;
  myQuestion: boolean = false;
  pageSize: number = 10;
  pageNumber: number = 0;
  showMore: boolean = false;
  insertQuestionMsg: string;
  loading: boolean = false;
  error = "no_error";
  loadingAnswer: boolean = false;
  
  searchForm = new FormGroup({
    topic: new FormControl(null),
    freeText: new FormControl(null),
    myQuestion: new FormControl(null)
  });

  questionForm = new FormGroup({
    topic: new FormControl('', [Validators.required]),
    question: new FormControl('', [Validators.required])
  });

  answerForm = new FormGroup({
    answer: new FormControl('', [Validators.required])
  });

  constructor(
    private commonService: CommonService,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log("Tender id = " + this.tenderId);

    if (this.openedFrom === 'participation') {
      this.insertQuestionMsg = 'Non hai trovato una risposta tra quelle già inserite? Inviaci la tua domanda.';
    } else if (this.openedFrom === 'tender') {
      this.insertQuestionMsg = 'Aiuta i partecipanti alla gara a capire meglio di cosa si tratta: insersci alcune domande a cui poi potrai dare risposta.';
    }

    this.commonService.getStandardService().stdSystemListsListNameGet("QUESTION_TOPICS").subscribe(
      (data) => {
        this.topics = data.items;
      },
      error => {
        console.log(error);
      }
    );

    this.searchQuestions();
  }

  searchQuestions() {
    this.pageNumber = 0;
    this.questions = [];

    this.topicCode = this.searchForm.get('topic').value;
    this.freeText = this.searchForm.get('freeText').value;
    this.myQuestion = this.searchForm.get('myQuestion').value;

    this.loadQuestions();
  
  }

  loadQuestions() {
    this.commonService.getQuestionService().tenderQuestionGet(
      this.tenderId,
      this.topicCode,
      this.freeText,
      this.myQuestion,
      this.pageSize,
      this.pageNumber
    ).subscribe(
      (res: QuestionList) => {
        this.questions =  this.questions.concat(res.questions);
        this.showMore = res.paging.pageNumber < (res.paging.totalPages - 1);
      },
      error => {
        console.error(error);
      }
    );
  }

  loadMore() {
    this.pageNumber = this.pageNumber + 1;
    this.loadQuestions();
  }

  goToTenderDetail() {
    if (this.openedFrom === 'tender') {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'tenderDetail', "tenderId": this.tenderId } });
        //window.open('/areariservata?tabToLoad=tenderDetail&tenderId=' + this.tenderId, '_self');
    } else if (this.openedFrom === 'participation') {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'participationDetail', "tenderId": this.participationId } });
        //window.open('/areariservata?tabToLoad=participationDetail&tenderId=' + this.tenderId, '_self');
    }
  }

  submitQuestion() {
    this.loading = true;
    if (!this.questionForm.valid) {
      const controls = this.questionForm.controls;
      Object.keys(controls).forEach(controlName => controls[controlName].markAsDirty());
      console.log("Invalid question form");
      this.loading = false;
      return;
    }
    console.log("Question submit");

    let formValues = this.questionForm.getRawValue();
    console.log(formValues);

    let question: Question = formValues;
    question.tenderId = this.tenderId;

    this.commonService.getQuestionService().tenderQuestionPost(question).subscribe(
        (res: Question) => {
            this.loading = false;
            
            let questionPanel: HTMLElement = document.getElementById("ngQuestionPanel") as HTMLElement;
            questionPanel.click();

            this.questionForm.reset();
            
            var that = this;

            setTimeout(function () {
                that.resetError();
            }, 3000);

            this.searchQuestions();
        },
        error => {
            this.loading = false;
            this.error = "Si è verificato un errore durante il salvataggio della domanda. Riprovare più tardi.";
        }
      );


  }

  submitAnswer(question: Question) {
    this.loadingAnswer = true;

    if (!this.answerForm.valid) {
        const controls = this.answerForm.controls;
        Object.keys(controls).forEach(controlName => controls[controlName].markAsDirty());
        this.loadingAnswer = false;
        return;
      }
      console.log("Answer submit");

      question.answer = this.answerForm.value.answer;

      this.commonService.getQuestionService().tenderQuestionQuestionIdPut(question.id, question).subscribe(
          (res: Question) => {
            this.loadingAnswer = false;
            this.answerForm.reset();
            this.searchQuestions();
          },
          error => {
              this.loadingAnswer = false;
              console.log(error);
          }
          
      );

  }

  resetError() {
    this.error = 'no_error';
  }

  getTopicDescription(topicCode: string) {
    let topics = this.topics.filter(topic => topic.code === topicCode);
    return topics[0].description;
  }


  isEditable() {
      return this.editable === 'true' ? true : false;
  }
}
